module.exports = __webpack_public_path__ + "static/media/football6.f167a3ff.png";